import {createSlice} from '@reduxjs/toolkit';

const getInitialState = () => {
    return {
        fwuAvailableInfo: undefined,
        holderFwuAvailableInfo: undefined,
    };
};

export const slice = createSlice({
    name: 'fwu',
    initialState: getInitialState(),
    reducers: {
        setFwuAvailableInfo: (state, action) => {
            const {isHolder, fwuAvailableInfo} = action.payload;
            const data = isHolder ? {holderFwuAvailableInfo: fwuAvailableInfo} : {fwuAvailableInfo};

            return {
                ...state,
                ...data,
            };
        },
        clearHolderFwuInfo: (state) => {
            return {
                ...state,
                holderFwuAvailableInfo: undefined,
            };
        },
        resetFwuState: () => {
            return {
                state: getInitialState(),
            };
        },
    },
});

export const {setFwuAvailableInfo, clearHolderFwuInfo, resetFwuState} = slice.actions;

export default slice.reducer;
